import React, { useEffect } from 'react';
import styles from '@/common/containers/Modals/LegalTaskFinished/styles.less';
import Modal from '@/common/components/Modal/index';
import Button from '@mui/material/Button';
import { useToggle } from '@/common/hooks/index';
import { Storage } from '@/common/utils/index';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import { routes } from '@/app/routing/index';
import { useHistory } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const LegalTaskFinished = () => {
  const { t } = useTranslation();
  const decedentId = useCurrentDecedentId();
  const [open, toggleOpen] = useToggle(false);
  const history = useHistory();

  useEffect(() => {
    if (!Storage.get(`legalFinishedAlert.${decedentId}`)) {
      toggleOpen(true);
    }
  }, [decedentId, toggleOpen]);

  const onClose = () => {
    Storage.set(`legalFinishedAlert.${decedentId}`, 1);
    toggleOpen();
    history.push(`${routes.dashboard.editQuestions}?module=legal`);
  };

  return (
    <Modal
      className={styles.modal}
      overlayClassname={styles.modalOverlay}
      open={open}
      overlay
    >
      <h4 className={styles.modalTitle}>
        {t('You have completed all initial legal tasks!')}
      </h4>
      <div className={styles.modalDescription}>
        <p>
          <Trans
            i18nKey="Please note that additional <1>legal tasks</1> may be generated based on responses to the <2>legal tasks</2> questionnaire. In this case, <3>PAEM After Care<7></7></3> will automatically bring you back to the legal tasks list. It is recommended you complete these additional <4>legal tasks</4> before proceeding with <5>Main</5> and/or <6>Assets tasks</6>."
            components={{
              1: <b />,
              2: <b />,
              3: <b />,
              4: <b />,
              5: <b />,
              6: <b />,
              7: <CopyrightSup />,
            }}
          />
        </p>
        <br />
        <p>
          <Trans
            i18nKey="Close this window to proceed to the <1>legal tasks</1> questionnaire."
            components={{ 1: <b /> }}
          />
        </p>
      </div>
      <div className={styles.modalBtns}>
        <Button
          variant="contained"
          onClick={onClose}
          data-testid="confirmModal-confirm"
        >
          {t('Close')}
        </Button>
      </div>
    </Modal>
  );
};

export default LegalTaskFinished;
